
  /* ---- gallery carousel (arrows/dots; color select slides to that image) ---- */
  (function(){
    var track=document.getElementById('pdpTrack'); if(!track) return;
    var frames=track.children, n=frames.length, i=0;
    var prev=document.getElementById('pdpPrev'), next=document.getElementById('pdpNext'), dots=document.querySelectorAll('.sk-pdp-dot');
    var counter=document.getElementById('pdpCount'), bar=document.querySelector('#pdpBar i');
    function go(k){ i=((k%n)+n)%n; track.style.transform='translateX('+(-i*100)+'%)'; dots.forEach(function(d,di){ d.classList.toggle('on',di===i); }); if(counter) counter.textContent=(i+1); if(bar) bar.style.width=(((i+1)/n)*100)+'%'; }
    if(bar) bar.style.width=((1/n)*100)+'%';
    if(prev) prev.addEventListener('click',function(){ go(i-1); });
    if(next) next.addEventListener('click',function(){ go(i+1); });
    dots.forEach(function(d){ d.addEventListener('click',function(){ go(+d.getAttribute('data-i')); }); });
    document.getElementById('pdpGallery').addEventListener('keydown',function(e){ if(e.key==='ArrowLeft'){e.preventDefault();go(i-1);} else if(e.key==='ArrowRight'){e.preventDefault();go(i+1);} });
    window.__pdpGoToSrc=function(src){ var base=(src||'').split('?')[0].replace(/^https?:/,''); for(var k=0;k<frames.length;k++){ if((frames[k].getAttribute('data-src')||'').replace(/^https?:/,'')===base){ go(k); return true; } } return false; };
  })();

  /* ---- info tabs (Details / Fit & Fabric / Shipping & Returns) ---- */
  (function(){
    var tabs=document.querySelectorAll('.sk-pdp-tab'); if(!tabs.length) return;
    tabs.forEach(function(t){ t.addEventListener('click',function(){
      var id=t.getAttribute('data-tab');
      tabs.forEach(function(x){ x.classList.toggle('on',x===t); });
      document.querySelectorAll('.sk-pdp-panel').forEach(function(pnl){ pnl.classList.toggle('on',pnl.getAttribute('data-panel')===id); });
    }); });
  })();

  /* ---- Size Guide: open the size-chart in a modal card (delegated on document, so it works even though
         the modal markup is parsed AFTER this script — the old direct-bind returned early on a null modal
         and the link fell through to /pages/size-chart) ---- */
  (function(){
    function m(){ return document.getElementById('skSizeGuide'); }
    function fit(){var modal=m();if(modal)modal.querySelector('.sk-sg-body').style.zoom='';}
    document.addEventListener('click',function(e){
      var modal=m(); if(!modal) return;
      if(e.target.closest && e.target.closest('.sk-pdp-sizeguide')){ e.preventDefault(); modal.hidden=false; document.body.style.overflow='hidden'; requestAnimationFrame(fit); return; }
      if((e.target.closest && e.target.closest('.sk-sg-x')) || e.target===modal){ modal.hidden=true; document.body.style.overflow=''; }
    });
    document.addEventListener('keydown',function(e){ var modal=m(); if(modal && e.key==='Escape' && !modal.hidden){ modal.hidden=true; document.body.style.overflow=''; } });
    window.addEventListener('resize',function(){ var modal=m(); if(modal && !modal.hidden) fit(); });
  })();

